"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _winDoc = require("win-doc");
var _createEl = require("create-el");
var _cssQuerySelector = _interopRequireDefault(require("css-query-selector"));
var _reshowConstant = require("reshow-constant");
var _store = _interopRequireDefault(require("./store.js"));
var _stylesToCSS = _interopRequireDefault(require("./stylesToCSS.js"));
var _getStyleTagId = _interopRequireDefault(require("./getStyleTagId.js"));
//@ts-check

/**
 * @typedef {object} CSSProps
 * @property {string[]} styleIds
 * @property {object} styleObjMap
 * @property {object} styleRuleMap
 */
/**
 * @param {CSSProps} props
 */
var appendCss = function appendCss(_ref) {
  var styleIds = _ref.styleIds,
    styleObjMap = _ref.styleObjMap,
    styleRuleMap = _ref.styleRuleMap;
  styleIds.forEach(function (key) {
    _store["default"].registry[key] = styleObjMap[key];
    var id = (0, _getStyleTagId["default"])(key);
    var css = styleRuleMap[key];
    if (!(0, _winDoc.hasWin)()) {
      console.log("<style id=\"" + id + "\">" + css + "</style>");
      return;
    }
    var styleDom = _cssQuerySelector["default"].one("#" + id);
    if (styleDom) {
      styleDom.innerHTML = css;
    } else {
      styleDom = (0, _createEl.create)("style")()({
        id: id,
        innerHTML: css
      });
      (0, _createEl.inject)(function () {
        return _cssQuerySelector["default"].one("head");
      })(styleDom);
    }
  });
};

/**
 * @param {object} [styles]
 */
var injectStyle = function injectStyle(styles) {
  if (styles) {
    (0, _reshowConstant.KEYS)(styles).forEach(function (key) {
      return _store["default"].newStyles.push(styles[key]);
    });
  }
  if (!_store["default"].newStyles.length) {
    // In Node (Server Side)  or Styles are already injected
    return null;
  }
  var compiled = (0, _stylesToCSS["default"])(_store["default"].newStyles);
  _store["default"].newStyles = [];
  if (compiled.styleIds.length) {
    appendCss(compiled);
  }
};
var _default = exports["default"] = injectStyle;
module.exports = exports.default;